module.exports = __webpack_public_path__ + "static/media/tips1-3-found.31e33237.png";